import { render, staticRenderFns } from "./TermsPopUp.vue?vue&type=template&id=0f93406b&scoped=true"
import script from "./TermsPopUp.vue?vue&type=script&lang=js"
export * from "./TermsPopUp.vue?vue&type=script&lang=js"
import style0 from "./TermsPopUp.vue?vue&type=style&index=0&id=0f93406b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f93406b",
  null
  
)

export default component.exports